import React from 'react'
import {
  ModulePanel,
  ModuleHeader,
  ModuleBody,
  ModuleFooter
} from 'containers/purchase/modules/module_panel'
import { useTranslation } from 'react-i18next'
import IryoRouteForm from './iryo_route_form'

const IryoRouteModule = (props) => {
  const { config, machine, status } = props
  const [current, send] = machine
  const { i18n } = useTranslation()

  const formName = props.formName.toUpperCase()

  const setForm = (form) => {
    send({ type: `${formName}_CHANGE`, form })
  }

  return (
    <ModulePanel>
      <ModuleHeader
        status={status}
        onClick={() =>
          status === 'completed'
            ? send(`REOPEN_${formName}STEP`.replace('_FORM', ''))
            : null
        }
      >
        <span>
          <i className="fa fa-map-marker me-2" aria-hidden="true"></i>
          {props.title}
        </span>
      </ModuleHeader>
      <ModuleBody status={status}>
        <IryoRouteForm
          setForm={setForm}
          config={config}
          machine={machine}
          destination={config.destination.slug}
        />
      </ModuleBody>
      <ModuleFooter {...props} />
    </ModulePanel>
  )
}

export default IryoRouteModule
